import React from 'react';
import Text from '../../../General/Text';
import { ReactComponent as NoInvoicesIcon } from '../../../../images/mis-boletas/empty-error.svg';
import Wrapper from './styles/EmptyStyled';

const Empty = () => (
  <Wrapper>
    <NoInvoicesIcon />
    <Text
      size="18px"
      weight="600"
      color="#21102E"
      margin="30px 0 0 0"
      align="center"
      text="NO HAY BOLETAS"
    />
    <Text
      size="16px"
      weight="400"
      color="#21102E"
      margin="10px 0 0 0"
      align="center"
      text="Desde el próximo mes verás en esta sección el listado de tus boletas."
    />
  </Wrapper>
);

export default Empty;
